import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import type { KidProfile } from "./types";

interface Props {
  kid: Pick<KidProfile, "id" | "firstName" | "lastName" | "dateOfBirth" | "ageGroup" | "batchName" | "batchId" | "status">;
}

function ageFromDob(dob: string): number {
  const today = new Date();
  const birth = new Date(dob);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age;
}

export function KidHeroBanner({ kid }: Props) {
  const age = ageFromDob(kid.dateOfBirth);

  return (
    <div
      className="bg-gradient-to-br from-slate-800 to-slate-700 text-white rounded-xl px-5 py-5 md:px-8 md:py-6 flex items-center gap-5 md:gap-8"
      data-testid="kid-hero-banner"
    >
      {/* Jersey-style number badge */}
      <div className="shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/10 border-2 border-white/30 flex items-center justify-center">
        <span className="text-2xl md:text-3xl font-black text-white tracking-tight">
          #{kid.id}
        </span>
      </div>

      {/* Identity */}
      <div className="min-w-0">
        <h1 className="text-xl md:text-2xl font-bold truncate" data-testid="kid-full-name">
          {kid.firstName} {kid.lastName}
        </h1>
        <p className="text-slate-300 text-sm mt-0.5">
          Age {age} · {kid.ageGroup}
        </p>
        <div className="flex flex-wrap items-center gap-2 mt-2">
          {kid.batchId ? (
            <Link to={`/coach/batches/${kid.batchId}`}>
              <Badge className="bg-white/15 text-white border-white/20 border hover:bg-white/25 text-xs cursor-pointer">
                {kid.batchName}
              </Badge>
            </Link>
          ) : (
            <Badge className="bg-white/15 text-white border-white/20 border hover:bg-white/15 text-xs">
              {kid.batchName}
            </Badge>
          )}
          {kid.status === "active" ? (
            <Badge className="bg-green-500/20 text-green-300 border-green-400/30 border hover:bg-green-500/20 text-xs">
              Active
            </Badge>
          ) : (
            <Badge className="bg-red-500/20 text-red-300 border-red-400/30 border hover:bg-red-500/20 text-xs">
              Inactive
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
}
